const UNFOLDED_SHIPPING_DEFAULT_VARIANT = "b";

export const useUnfoldedShippingEnabled = () => {
	return true
};

export const useUnfoldedShippingCookie = () => {
	return UNFOLDED_SHIPPING_DEFAULT_VARIANT
};
